import React, { Dispatch } from 'react';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import { NotificationsActions } from '../notifications/notificationsActions';
import { NotificationAction } from '../notifications/notificationsActionType';
import { ErrorResolution, ErrorResolutionTypes } from './errorResolution';
import { ErrorBoxAction } from '../errorBox/errorBoxActionType';
import { ErrorBoxActions } from '../errorBox/errorBoxActions';

export class ErrorResolutionActions {
    public static processErrorResolution(
        errorResolution: ErrorResolution,
        errorMessageIdPrefix?: string,
        extras?: {
            challengerPid?: string;
        },
    ): any {
        switch (errorResolution.type) {
            case ErrorResolutionTypes.ERROR_CODE_MESSAGE:
                return (dispatch: Dispatch<NotificationAction>) => {
                    dispatch(
                        NotificationsActions.showError(
                            TranslationHelpers.getFormattedMessage(
                                `${errorResolution.errorMessageId}`,
                            ),
                            errorResolution.title
                                ? TranslationHelpers.getFormattedMessage(errorResolution.title)
                                : null,
                        ),
                    );
                };

            case ErrorResolutionTypes.WARNING_CODE_MESSAGE:
                return (dispatch: Dispatch<NotificationAction>) => {
                    dispatch(
                        NotificationsActions.showWarning(
                            TranslationHelpers.getFormattedMessage(
                                `${errorMessageIdPrefix}.${errorResolution.errorCode}`,
                            ),
                        ),
                    );
                };

            case ErrorResolutionTypes.ERROR_BOX:
                return (dispatch: Dispatch<ErrorBoxAction>) => {
                    dispatch(
                        ErrorBoxActions.showBox(
                            TranslationHelpers.getFormattedMessage(
                                `${errorMessageIdPrefix}.${errorResolution.errorCode}`,
                            ),
                        ),
                    );
                };

            case ErrorResolutionTypes.ERROR_LIST:
                const message = (
                    <div>
                        {TranslationHelpers.getFormattedMessage(
                            `${errorMessageIdPrefix}.${errorResolution.errorCode}`,
                        )}
                        <ul>
                            {errorResolution.errorMessages.map((errorMessage) => (
                                <li>{errorMessage}</li>
                            ))}
                        </ul>
                    </div>
                );

                return (dispatch: Dispatch<NotificationAction>) => {
                    dispatch(NotificationsActions.showWarning(message));
                };

            case ErrorResolutionTypes.REDIRECTING:
            case ErrorResolutionTypes.MEMBER_NOT_LINKED_ERROR:
            case ErrorResolutionTypes.RE_AUTH:
                return {
                    payload: {},
                    type: 'EMPTY',
                };

            case ErrorResolutionTypes.GENERIC_MESSAGE:
                return (dispatch: Dispatch<NotificationAction>) => {
                    dispatch(
                        NotificationsActions.showWarning(
                            TranslationHelpers.getFormattedMessage(
                                errorResolution.errorMessageId
                                    ? errorResolution.errorMessageId
                                    : errorMessageIdPrefix
                                    ? errorMessageIdPrefix
                                    : 'notifications.something_went_wrong',
                            ),
                        ),
                    );
                };

            default:
                return (dispatch: Dispatch<NotificationAction>) => {
                    dispatch(
                        NotificationsActions.showWarning(
                            TranslationHelpers.getFormattedMessage(
                                errorMessageIdPrefix
                                    ? errorMessageIdPrefix
                                    : 'notifications.something_went_wrong',
                            ),
                        ),
                    );
                };
        }
    }
}
